<div class="form-group">
  <label class="form-input-label" [for]="field.id">
    {{ field.label }}

    <span *ngIf="field.validation?.required">*</span>
  </label>

  <select
  *ngIf="field.options"
  [id]="field.id"
  [formControl]="control"
  class="form-input"
  (change)="onChange()"
>
  <option *ngFor="let option of field.options" [value]="option[0]" [title]="option[1]">
    {{ option[1] }}
  </option>
</select>

  <input
    class="form-input"
    *ngIf="!field.options"
    [id]="field.id"
    [formControl]="control"
    [placeholder]="field.placeholder"
    (blur)="onChange()"
    [attr.type]="'text'"
  />

  <div *ngIf="control?.touched && control?.invalid" class="form-input-label field-validation abs-field">
    <div *ngIf="control?.errors?.required && field.validationMessages?.required">
      {{ field.validationMessages.required }}
    </div>
    <div *ngIf="control?.errors?.minlength && field.validationMessages?.minLength">
      {{ field.validationMessages.minLength }}
    </div>
    <div *ngIf="control?.errors?.maxlength && field.validationMessages?.maxLength">
      {{ field.validationMessages.maxLength }}
    </div>
    <div *ngIf="control?.errors?.pattern && field.validationMessages?.pattern">
      {{ field.validationMessages.pattern }}
    </div>
  </div>
</div>
